
import Vue from 'vue'

const transformer = ({ folio, requisition_number: requisitionNumber, 
                       sinister_number: sinisterNumber,
                       sinister_roads: sinisterId }) => ({
    folio, requisitionNumber, sinisterNumber, sinisterId
})

export default (purchaseOrder) => {
  const poId = purchaseOrder.id || purchaseOrder
  return Vue.$http.get(`purchase/order/${poId}/related_sinisters/`)
    .then(({ data }) => data.related_sinisters.map(transformer))
}


// WEBPACK FOOTER //
// ./src/services/purchase/purchaseOrder/fetchOrderRelatedSinisters.js